// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__16aIj","header":"ClearentDisclaimer_header__19uSp","inner":"ClearentDisclaimer_inner__1UhhV"};